import apiClient from './apiClient';

export const emailAgentApi = {
  getStatus: () => apiClient.get('/email-agent/status').then(r => r.data),
  start: () => apiClient.post('/email-agent/start').then(r => r.data),
  stop: () => apiClient.post('/email-agent/stop').then(r => r.data),
  restart: () => apiClient.post('/email-agent/restart').then(r => r.data),

  testOpenAI: () => apiClient.post('/email-agent/test-openai').then(r => r.data),
  testSmtp: () => apiClient.post('/email-agent/test-smtp').then(r => r.data),
  testImap: () => apiClient.post('/email-agent/test-imap').then(r => r.data),

  getLogs: (params = {}) => apiClient.get('/email-agent/logs', { params }).then(r => r.data),
  getStats: () => apiClient.get('/email-agent/stats').then(r => r.data),

  getBlacklist: () => apiClient.get('/email-agent/blacklist').then(r => r.data),
  addToBlacklist: (email, grund) => apiClient.post('/email-agent/blacklist', { email, grund }).then(r => r.data),
  removeFromBlacklist: (email) => apiClient.delete(`/email-agent/blacklist/${encodeURIComponent(email)}`).then(r => r.data),

  // Auto-Antwort-Sperre
  getAutoAntwortSperren: () => apiClient.get('/email-agent/auto-antwort-sperre').then(r => r.data),
  addAutoAntwortSperre: (email, grund) => apiClient.post('/email-agent/auto-antwort-sperre', { email, grund }).then(r => r.data),
  removeAutoAntwortSperre: (email) => apiClient.delete(`/email-agent/auto-antwort-sperre/${encodeURIComponent(email)}`).then(r => r.data),

  getKonversationen: (anfrageId) => apiClient.get(`/email-agent/konversationen/${anfrageId}`).then(r => r.data),
  getPending: () => apiClient.get('/email-agent/pending').then(r => r.data),

  // Provider-Wechsel: 'gmail', 'outlook', 'imap'
  switchProvider: (provider) => apiClient.post('/email-agent/switch-provider', { provider }).then(r => r.data),

  // ===== KORREKTUREN / KI-TRAINING =====

  // Korrekturen
  getCorrections: () => apiClient.get('/email-agent/corrections').then(r => r.data),
  createCorrection: (data) => apiClient.post('/email-agent/corrections', data).then(r => r.data),
  updateCorrection: (id, data) => apiClient.put(`/email-agent/corrections/${id}`, data).then(r => r.data),
  deleteCorrection: (id) => apiClient.delete(`/email-agent/corrections/${id}`).then(r => r.data),
  toggleCorrection: (id) => apiClient.patch(`/email-agent/corrections/${id}/toggle`).then(r => r.data),

  // Verarbeitete E-Mails
  getProcessedEmails: (params = {}) => apiClient.get('/email-agent/processed-emails', { params }).then(r => r.data),
  getProcessedEmail: (id) => apiClient.get(`/email-agent/processed-emails/${id}`).then(r => r.data),

  // Intents
  getIntents: () => apiClient.get('/email-agent/intents').then(r => r.data),

  // ===== MAIL SORTING / KUNDENORDNER =====

  // Sortierungs-Status und -Konfiguration
  getSortingStatus: () => apiClient.get('/email-agent/sorting/status').then(r => r.data),

  // Konfiguration aktualisieren
  updateSortingConfig: (config) => apiClient.put('/email-agent/sorting/config', config).then(r => r.data),

  // Basis-Ordner initialisieren
  initializeSorting: () => apiClient.post('/email-agent/sorting/initialize').then(r => r.data),

  // Kundenordner auflisten
  getSortingFolders: () => apiClient.get('/email-agent/sorting/folders').then(r => r.data),

  // Matching testen
  testSortingMatch: (data) => apiClient.post('/email-agent/sorting/test', data).then(r => r.data)
};

export default emailAgentApi;
